import React, { useEffect, useState } from "react";
import Body from "../../body/BodyPage";
import MainLinks from "../../navlinks/MainLinks";
import { useTranslation } from "react-i18next";
import {
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
} from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";
import SendAFax from "../../../views/popups/users/SendAFax";
import ReceivedFax from "../../../views/popups/users/ReceivedFax";
import SentFax from "../../../views/popups/users/SentFax";
import Logo from "../../images/StreamsAIWhite.png";
import LogoDark from "../../images/StreamsAI.png";
import BlackMode from "../../NightMode/BlackTheme";
function SendFax() {
  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [isActive, setIsActive] = useState("tab1");
  const [faxPhoneNums, setfaxPhoneNums] = useState([]);
  const [uniqueid, setuniqueid] = useState("");
  const [faxDomain, setfaxDomain] = useState("");
  const [primaryFax, setprimaryFax] = useState("");
  const [userList, setuserList] = useState([]);
  const [groupname, setgroupname] = useState(null);
  const [groupFaxFlag, setgroupFaxFlag] = useState(false);

  const [basicActive, setBasicActive] = useState(isActive);
  const handleBasicClick = (value) => {
    if (value === basicActive) {
      return;
    }
    setBasicActive(value);
  };

  useEffect(() => {
    const storedData = localStorage.getItem("faxParams");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setfaxPhoneNums(parsedData.faxNumbers || []);
      setuniqueid(parsedData.uniqueid || "");
      setfaxDomain(parsedData.faxDomain || "");
      setprimaryFax(parsedData.primaryFax || "");
      setuserList(parsedData.userList || []);
      setgroupname(parsedData.groupname || null);
      setgroupFaxFlag(parsedData.groupFaxFlag || false);
      setIsActive(parsedData.isActive || "tab1");

      // Optional: Clear the data after reading if you don't need it anymore
      // localStorage.removeItem("faxParams");
    }
  }, []);

  useEffect(() => {
    if (isActive === "tab1") {
      setBasicActive(isActive);
    }
  }, [isActive]);

  const [themeBasedLogo, setThemeBasedLogo] = useState(
    localStorage.getItem("selectedColorTheme")
  );
  console.log(themeBasedLogo, "themeBasedLogo");
  useEffect(() => {
    if (themeBasedLogo === "system") {
      const systemPrefersDark = window.matchMedia(
        "(prefers-color-scheme: dark)"
      ).matches;
      if (systemPrefersDark) {
        setThemeBasedLogo("dark");
      } else {
        setThemeBasedLogo(localStorage.getItem("selectedColorTheme"));
      }
      console.log(systemPrefersDark, "systemPrefersDark");
    }
  }, [themeBasedLogo]);

  return (
    <React.Fragment>
      <>
        <div className="d-none">
          <BlackMode />
        </div>
        <div className="card">
          <a className="navbar-brand p-3" onClick={(e) => e.preventDefault()}>
            <img
              src={themeBasedLogo == "dark" ? Logo : LogoDark}
              width={170}
            />
          </a>
        </div>

        <div className="card mt-1" >
          <div style={{ minHeight: "calc(100vh - 71px)" }}>
            <MDBTabs className="mb-3 pt-3">
              <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab1")}
                  active={basicActive === "tab1"}
                >
                  {t("SendaFax")}
                </MDBTabsLink>
              </MDBTabsItem>
              <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab2")}
                  active={basicActive === "tab2"}
                >
                  {t("ReceivedFaxMessages")}
                </MDBTabsLink>
              </MDBTabsItem>
              <MDBTabsItem>
                <MDBTabsLink
                  onClick={() => handleBasicClick("tab3")}
                  active={basicActive === "tab3"}
                >
                  {t("SentFaxMessages")}
                </MDBTabsLink>
              </MDBTabsItem>
            </MDBTabs>

            <MDBTabsContent>
              <MDBTabsPane open={basicActive === "tab1"}>
                {/* Tab 1 content */}
                <SendAFax
                  faxPhoneNums={faxPhoneNums}
                  uniqueid={uniqueid}
                  faxDomain={faxDomain}
                  primaryFax={primaryFax}
                  groupFaxFlag={groupFaxFlag}
                  forwardFlag={false}
                  userList={userList}
                  groupname={groupname}
                />
              </MDBTabsPane>
              <MDBTabsPane open={basicActive === "tab2"}>
                {/* Tab 2 content */}
                <ReceivedFax
                  uniqueid={uniqueid}
                  groupFaxFlag={groupFaxFlag}
                  faxDomain={faxDomain}
                  primaryFax={primaryFax}
                  userList={userList}
                  faxPhoneNums={faxPhoneNums}
                  isActive={basicActive === "tab2"}
                  groupname={groupname}
                />
              </MDBTabsPane>
              <MDBTabsPane open={basicActive === "tab3"}>
                {/* Tab 3 content */}

                <SentFax
                  uniqueid={uniqueid}
                  groupFaxFlag={groupFaxFlag}
                  faxDomain={faxDomain}
                  primaryFax={primaryFax}
                  userList={userList}
                  faxPhoneNums={faxPhoneNums}
                  isActive={basicActive === "tab3"}
                  groupname={groupname}
                />
              </MDBTabsPane>
            </MDBTabsContent>
          </div>

          <Tooltip
            anchorSelect=".EditProfile"
            place="top"
            className="exampleTooltip"
          >
            Edit Profile
          </Tooltip>
          <Tooltip
            anchorSelect=".RemoveProfile"
            place="top"
            className="exampleTooltip"
          >
            Remove Profile
          </Tooltip>

          <Tooltip
            anchorSelect=".DownloadToolTip"
            place="top"
            className="exampleTooltip"
          >
            Download
          </Tooltip>
          <Tooltip
            anchorSelect=".ShareToolTip"
            place="top"
            className="exampleTooltip"
          >
            Forward Fax
          </Tooltip>
          <Tooltip
            anchorSelect=".deleteToolTip"
            place="top"
            className="exampleTooltip"
          >
            Delete
          </Tooltip>
          <Tooltip
            anchorSelect=".resendToolTip"
            place="top"
            className="exampleTooltip"
          >
            Resend
          </Tooltip>
        </div>
      </>
    </React.Fragment>
  );
}

export default SendFax;
